import React from "react";

import { Container } from "@components/Layout/Container";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import * as Styled from "./NavBar.styled";

export interface Props {
  testId?: string;
  id?: string;
}

export const NavBar: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <React.Fragment>
      <Styled.GlobalStyle />

      <TestWrapper testId={props.testId}>
        <Styled.Header id={props.id}>
          <Container>
            <Styled.Body>{props.children}</Styled.Body>
          </Container>
        </Styled.Header>
      </TestWrapper>
    </React.Fragment>
  );
};
